import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import uiPagination from 'angular-ui-bootstrap/src/pagination';
// import {UputnicaComponent} from './uputnica.component.js';
import {GridComponent} from './grid/grid.js';
import FormComponent from './form/form.js';

const uputnica = angular.module('uputnica', [uiModal, uiPagination]);

// uputnica.component('uputnica', UputnicaComponent);
uputnica.component('uputnicaForm', FormComponent);
uputnica.component('uputnicaGrid', GridComponent);

export {uputnica};



// WEBPACK FOOTER //
// ./app/components/uputnica/uputnica.js